export default __webpack_public_path__ + "static/media/p2-1.f5025f5b.png";